import { createContext } from "react";

import type { useStorePageEditor } from "./draft/use-store-page-editor";

type Editor = ReturnType<typeof useStorePageEditor>;

export type EditModeValue = {
  /** Server-checked (flag + permission) — false means this viewer never sees
   * any edit affordance anywhere on the page, editing or not. */
  canEdit: boolean;
  canReview: boolean;
  editing: boolean;
  enterEditing: () => void;
  /** Warns (native `confirm`) when there are unsaved changes; otherwise exits
   * immediately. Always safe to call. */
  exitEditing: () => void;
  slug: string;
  editor: Editor;
};

export const editModeContext = createContext<EditModeValue | null>(null);
